module.exports = __webpack_public_path__ + "img/Gemeinde_Train.77479262.png";